import React from 'react'
import { AdminLayout } from '@/components/Layout/Layout'
// import { Button } from '@mui/material'
import TestCaseForm from './form/TestCaseForm'
import { useNavigate } from 'react-router-dom'
import Button from '@/shared/ui/Buttons/Button'
import api from '@/shared/api/api'
import { ContentType } from '@/shared/api/gen/http-client'
import { BodyCreateTestcasesApiTestCasesPost } from '@/shared/api/gen/data-contracts'

type Props = {}

function CreateTestCase({}: Props) {
    const navigate = useNavigate();
    const onSubmit = (data: BodyCreateTestcasesApiTestCasesPost) => {
        const {attachment, ...restData} = data;
        // @ts-expect-error ts(2322)
        const attachmentFiles: FileList = attachment;
        const  attachmentData = attachmentFiles?.length > 0 ? {attachment: attachmentFiles[0]}: {attachment: null}
        api.test_cases.createTestcasesApiTestCasesPost(
            {...restData, ...attachmentData}
        ).then(el=>navigate(-1)) 
    }
    return (
        <AdminLayout>
            <div className='FormRow'>
                <Button onClick={() => navigate(-1)} style={{maxWidth: "100px"}}>Назад</Button>
            </div>
            <TestCaseForm defaultData={{}} onSubmit={onSubmit} />
        </AdminLayout>
    )
}

export default CreateTestCase;